/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

import { get } from 'lodash';
import {
  Row,
  Col,
  Modal,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  MenuItem
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Table from './UserTable';
import { createColumns, defaultSorts } from './config';
import adminApi from '../../services/admin-api';
import AdminModal from './Modal';
import DowntimeModal from './DowntimeModal';
import AdminAccessModal from './AdminAccessModal';

const Admin = ({ filters, downtime, downtimeActions, user }) => {
  const [users, setUsers] = useState([]);
  const [actionSection, setActionSection] = useState(null);
  const [editUser, setEditUser] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState(null);
  const [alertText, setAlertText] = useState(null);
  const [alertFunc, setAlertFunc] = useState(null);
  const [alertError, setAlertError] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [openDowntimeModal, setOpenDowntimeModal] = useState(false);
  const [openAdminAccessModal, setOpenAdminAccessModal] = useState(false);
  const [userRole, setUserRole] = useState('');

  const onClickOpenDowntime = () => {
    setOpenDowntimeModal(true);
  };

  const closeDowntimeModal = () => {
    setOpenDowntimeModal(false);
  };

  const onClickOpenAdminAccess = () => {
    setOpenAdminAccessModal(true);
  };

  const closeAdminAccessModal = () => {
    setOpenAdminAccessModal(false);
  };

  const fetchAllUsers = async () => {
    const u = await adminApi.getAllUsers();
    if (u) {
      const currentUser = get(
        u.filter(u => u.userId === user.userId),
        0,
        {}
      );

      if (currentUser.roles && currentUser.roles.length > 0) {
        setUserRole(currentUser.roles[0]);
      }
    }
    setUsers(u);
  };

  const onEdit = user => {
    setEditUser(user);
    setActionSection('edit');
  };

  const onSelectUser = checkedUsers => {
    setSelectedUsers(checkedUsers);
  };

  const headerFormatter = createColumns(onEdit, {
    setShowAlert,
    setAlertText,
    setAlertFunc,
    setAlertTitle
  });

  const onBulkEdit = () => {
    setEditUser(selectedUsers);
    setActionSection('edit');
  };

  const onCreate = () => {
    setActionSection('create');
  };

  const onSubmit = async updatedUsers => {
    if (updatedUsers.length) {
      const success = await adminApi.updateUsers(updatedUsers);

      if (success) {
        fetchAllUsers();
        setActionSection(null);
      }

      return success;
    }
  };

  const onCloseAlert = () => {
    setShowAlert(false);
    setAlertText(null);
    setAlertFunc(null);
    setAlertTitle(null);
    setAlertError(null);
  };

  const onSendAlert = async () => {
    const result = await alertFunc();
    if (result) {
      onCloseAlert();
      setAlertError(null);
    } else {
      setAlertError(
        'Something went wrong. Please try again. If the problem persists, contact your tech team.'
      );
    }
  };

  const closeModal = () => {
    setActionSection(null);
    setEditUser(null);
  };

  useEffect(() => {
    document.title = 'Admin | CVM Insights';
    fetchAllUsers();
  }, []);

  return (
    <div className="cvmi-admin__page">
      <Row>
        <Modal
          className="cvmi-admin__alert-modal"
          id="cvmi-admin__alert-modal"
          show={showAlert}
          onHide={onCloseAlert}
          backdrop
        >
          <div className="cvmi-admin__alert-modal-title">{alertTitle}</div>
          <div className="cvmi-admin__alert-modal-text">{alertText}</div>
          <div className="cvmi-admin__alert-action-buttons">
            <button
              onClick={onCloseAlert}
              className="cvmi-admin__alert-modal-cancel"
            >
              Cancel
            </button>
            <button
              className="cvmi-admin__alert-modal-action"
              onClick={onSendAlert}
            >
              Send
            </button>
          </div>
          <div className="cvmi-admin__alert-modal-error">{alertError}</div>
        </Modal>
        <AdminModal
          isOpen={actionSection === 'edit' || actionSection === 'create'}
          closeModal={closeModal}
          user={editUser}
          onSubmit={onSubmit}
          orgs={get(filters, ['fields', 'adminOrgMap', 'options'], [])}
          userRole={userRole}
        />
        <DowntimeModal
          isOpen={openDowntimeModal}
          onClose={closeDowntimeModal}
          downtimeActions={downtimeActions}
          messages={downtime ? downtime.messages : null}
        />
        <AdminAccessModal
          isOpen={openAdminAccessModal}
          onClose={closeAdminAccessModal}
          users={users}
          updateList={fetchAllUsers}
        />
        <Col>
          <h1>Admin</h1>
        </Col>
        <Col className="cvmi-admin__actions-row">
          <div className="cvmi-admin__actions-buttons-row">
            <button
              className="tvt-admin__button bulk-edit"
              onClick={onBulkEdit}
              disabled={selectedUsers.length < 2 || userRole !== 'admin'}
            >
              Bulk Edit
            </button>
            <button
              className="tvt-admin__button create"
              disabled={userRole !== 'admin'}
              onClick={onCreate}
            >
              Add New
            </button>
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="admin-modal__item-tooltip">
                  <div>Other actions</div>
                </Tooltip>
              }
            >
              <Dropdown
                id="tvt-header__dropdown-profile"
                className="cvmi-admi__options-button"
              >
                <Dropdown.Toggle
                  className="tvt-dropdown__btn tvt-header__dropdown-profile-avatar"
                  noCaret
                >
                  <FontAwesomeIcon
                    className="cvmi-admin-options__menu-icon"
                    icon="bars"
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu className="tvt-dropdown__menu">
                  <MenuItem
                    className="tvt-dropdown__menu-item"
                    onClick={onClickOpenDowntime}
                    disabled={userRole !== 'admin'}
                  >
                    Manage Downtime Message
                  </MenuItem>
                  <MenuItem
                    className="tvt-dropdown__menu-item"
                    onClick={onClickOpenAdminAccess}
                    disabled={userRole !== 'admin'}
                  >
                    Manage Admin Access
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Table
            showRank={false}
            data={users}
            headerFormatter={headerFormatter}
            defaultSorts={defaultSorts}
            onSelectCheckbox={onSelectUser}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Admin;
